import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, SecurityContext } from '@angular/core';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { UiPictureModule } from '@big-direkt/ui/picture';
import { UiSvgIconModule } from '@big-direkt/ui/svg-icon';
import { UiTagComponent } from '@big-direkt/ui/tag';
import { SanitizePipe } from '@big-direkt/utils/shared';
import { TranslocoDirective } from '@jsverse/transloco';
import { CardBaseComponent } from '../../card-base.component';
import { CardComponent } from '../card/card.component';
import { UiCardSubjectAreaNodeModel } from './card-subject-area-node.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'big-ui-card-subject-area-node',
    templateUrl: './card-subject-area-node.component.html',
    imports: [CardComponent, SanitizePipe, TranslocoDirective, UiLinkComponent, UiPictureModule, UiTagComponent, UiSvgIconModule, DatePipe],
})
export class CardSubjectAreaNodeComponent extends CardBaseComponent {
    public readonly securityContext: SecurityContext = SecurityContext.HTML;

    @Input() public data!: UiCardSubjectAreaNodeModel;
    @Input() public selectedAreaId!: number;
    @Input() public cardIndex!: number;
}
